(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = ["ProductService","$timeout","$location",'$anchorScroll','$uibModal','$window','AnaliticaService'];

    function AppController(ProductService,$timeout,$location,$anchorScroll,$uibModal,$window,AnaliticaService)
    {
        var vm = this;
        vm.carrito = [];
        vm.mostrarProdPopup = false;
        vm.loading = false;

        vm.autoPopup = function(){
            //console.log("Esperando");
            $timeout(function(){
                vm.mostrarProdPopup = true;
            },20000);
        };

        vm.init = function(){
        	if(localStorage.getItem("cart")){
	        	vm.carrito = JSON.parse(localStorage.getItem("cart"));
	        }
            AnaliticaService.pageView(document.title,$window.location.pathname+$window.location.search,$window.location.pathname+$window.location.search);
        };

        vm.existeProducto = function(prod_id){
        	var res = false;
        	for(var cont= 0;cont<vm.carrito.length && !res;cont++){
        		if(vm.carrito[cont].id==prod_id){
        			res = true;
				}
        	}
        	return res;
        };

        vm.nuevoProductoModal = "";
        vm.presupuesto = function(producto_id){
        	vm.loading = true;
        	ProductService.presupuestoProd(producto_id,function(data){
        		if(!vm.existeProducto(producto_id)){
	        		vm.carrito.push(data.producto);
	        		localStorage.setItem("cart", JSON.stringify(vm.carrito));
                    AnaliticaService.pageView('Budget added:'+data.producto['nombre'],data.producto['url']+'/added-budget',data.producto['url']+'/added-budget');
                    if($window.location.pathname != solicitud_url){
                        vm.nuevoProductoModal = $uibModal.open({
                              animation: true,
                              ariaLabelledBy: 'modal-title-top',
                              ariaDescribedBy: 'modal-body-top',
                              templateUrl: 'newproduct.html',
                              size: 'lg',
                              backdrop:'static',
                              controller: function($scope) {
                                $scope.okForm = function(){
                                    vm.nuevoProductoModal.close();
                                };
                                $scope.goBudget = function(){
                                    $window.location.href = solicitud_url;
                                };
                              
                              }
                        });
                    }

	        	}else{
                    if($window.location.pathname != solicitud_url){
                        vm.nuevoProductoModal = $uibModal.open({
                          animation: true,
                          ariaLabelledBy: 'modal-title-top',
                          ariaDescribedBy: 'modal-body-top',
                          templateUrl: 'existproduct.html',
                          size: 'lg',
                          backdrop:'static',
                          controller: function($scope) {
                            $scope.okForm = function(){
                                vm.nuevoProductoModal.close();
                            };
                            $scope.goBudget = function(){
                                $window.location.href = solicitud_url;
                            };
                          }
                        });
                    }
                }
        		vm.loading = false;
            });
        	//console.log(localStorage.getItem("cart"));
        	//console.log(vm.carrito);
        } 

        vm.eliminarCar = function(index){
            //console.log("eliminando");
            //console.log(index);
            vm.carrito.splice(index,1);
            localStorage.setItem("cart", JSON.stringify(vm.carrito));
        }
        vm.init();

        vm.getProducts = function(){
            var productos = [];
            for(var cont=0;cont<vm.carrito.length;cont++){
                productos.push(vm.carrito[cont].nombre);
            }
            return productos.join(", ");
        }
    }


})();